import React from 'react';
import { useTranslation } from 'react-i18next';
import IframeEmbed from '../../../components/patients/IframeEmbed';
import { apiZedocGetKnowledgeHubToken } from '../../../common/api/zedoc';
import PageBar from '../../../components/Layout/PageBar';

const KnowledgeHub = () => {
  const { t } = useTranslation();

  return (
    <div className="-mx-4 -my-6">
      <PageBar title={t('knowledgeHub')} isNewPresentation />
      <IframeEmbed
        apiSpec={apiZedocGetKnowledgeHubToken}
        params={{}}
        title={t('knowledgeHub')}
        toolName="knowledge hub tool"
      />
    </div>
  );
};

export default KnowledgeHub;
